// src/contexts/UserContext.js
import React, { createContext, useState } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [permissionTypes, setPermissionTypes] = useState([]);
    const [loading, setLoading] = useState(false);

    const selectUser = (userData) => {
        setUser(userData);
        setPermissionTypes(userData.permissionTypes || []);
    };

    const hasPermission = (permission) => {
        if (user?.role === 'ADMIN') return true;
        if (user?.role === 'MODERATOR') {
            return permissionTypes.includes(permission);
        }
        return false;
    };

    const clearUser = () => {
        setPermissionTypes([]);
        setUser(null);
    };

    return (
        <UserContext.Provider
            value={{
                user,
                selectUser,
                loading,
                hasPermission,
                clearUser,
            }}
        >
            {children}
        </UserContext.Provider>
    );
};
